var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgEth0101 = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 500 500",
    style: {
      enableBackground: "new 0 0 500 500"
    },
    xmlSpace: "preserve",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#3C3C3B;}\r\n\t.st1{fill:#343434;}\r\n\t.st2{fill:#8C8C8C;}\r\n\t.st3{fill:#141414;}\r\n\t.st4{fill:#393939;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M250.5,367.6v117.6l144-203.3L250.5,367.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M250.5,14.8l144,239.6l-144,85.7l-145-85.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M250.5,14.8v173.6l-145,65.9 M105.5,281.9l145,85.7v117.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M250.5,188.5v151.6l144-85.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M105.5,254.4l145-65.9v151.6"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgEth0101);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ETH-01-01.e56bae383f8abe3bb6d5be4d5386d6aa.svg";